import { InventoryPage } from 'pages/inventory';

export const InventoryView = () => {
  return <InventoryPage />;
};
